<template>
  <component
    :is="layoutComponent"
    :show-mobile-footer="$consumer"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'DynamicAuthLayout',
  computed: {
    layoutComponent () {
      const layout = this.$route.meta.layout
      if (layout === 'AccountLayout') {
        return defineAsyncComponent(() => import(/* webpackChunkName: "consumer-layout-AccountLayout" */ 'src/modules/consumer/layouts/AccountLayout.vue'))
      }

      // Default to PlainLayout
      return defineAsyncComponent(() => import(/* webpackChunkName: "auth-layout-PlainLayout" */ 'src/modules/auth/layouts/PlainLayout.vue'))
    }
  }
}
</script>
